"use strict";

exports.__esModule = true;
var _CalendarLoader = require("./CalendarLoader");
Object.keys(_CalendarLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CalendarLoader[key]) return;
  exports[key] = _CalendarLoader[key];
});